import { HttpClient } from '@angular/common/http';
import { Constants } from '../models/constants.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * Provides access to the application configuration.
 *
 * The configuration can be supplied via an appConfig.json,
 * or as a global object named "_RoomReservationConfig".
 *
 * "useHashRouting" and "assetPath" can only be configured when
 * using the _RoomReservationConfig object.
 *
 * @export
 * @class AppConfigService
 */
var AppConfigService = /** @class */ (function () {
    function AppConfigService(http) {
        this.http = http;
    }
    Object.defineProperty(AppConfigService, "globalConfig", {
        get: function () {
            return window._RoomReservationConfig || {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppConfigService, "hasGlobalConfig", {
        get: function () {
            return window._RoomReservationConfig !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppConfigService, "translationsPath", {
        get: function () {
            if (AppConfigService.hasGlobalConfig) {
                return AppConfigService.globalConfig.assetPath + 'i18n/';
            }
            else {
                return Constants.Urls.Translations;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppConfigService, "oauthUrl", {
        /**
         * Returns the oauth server url without trailing slash
         *
         * @readonly
         * @static
         * @type {string}
         * @memberof AppConfigService
         */
        get: function () {
            return AppConfigService.settings.oauthUrl.replace(/[/]*$/, '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppConfigService, "assetPath", {
        get: function () {
            if (AppConfigService.hasGlobalConfig) {
                return AppConfigService.globalConfig.assetPath;
            }
            else {
                return Constants.Urls.Assets;
            }
        },
        enumerable: true,
        configurable: true
    });
    AppConfigService.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (AppConfigService.hasGlobalConfig) {
                AppConfigService.settings = AppConfigService.globalConfig;
                resolve();
            }
            else {
                _this.http.get(Constants.Urls.AppConfig)
                    .toPromise()
                    .then(function (value) {
                    AppConfigService.settings = value;
                    AppConfigService.settings.assetPath = Constants.Urls.Assets;
                    resolve();
                })
                    .catch(function (reason) {
                    reject("Could not load file '" + Constants.Urls.AppConfig + "': " + JSON.stringify(reason));
                });
            }
        });
    };
    AppConfigService.ngInjectableDef = i0.defineInjectable({ factory: function AppConfigService_Factory() { return new AppConfigService(i0.inject(i1.HttpClient)); }, token: AppConfigService, providedIn: "root" });
    return AppConfigService;
}());
export { AppConfigService };
